// import { Update } from "@mui/icons-material";
import { api } from "../../api";
import { CreateQueryParams } from "../../functions/ResourceFunctions";
import { CreateCreditFacility, DisableCreditFacility } from "./HRSlice";
// import { CreateWeekendAllowance, GetAllWeekendAllowance } from "./HRSlice";
// import { a } from "@react-spring/web";

const hrService = () => {
  const hr = process.env.REACT_APP_BACKEND_HR_URL;
  const hrLeave = process.env.REACT_APP_BACKEND_HR_LEAVE_URL;
  const eps_env = process.env.REACT_APP_BACKEND_EPS_URL;
  const finance_env = process.env.REACT_APP_BACKEND_FINANCE_URL;
  const hr_api = api(hr);
  const hr_leave_api = api(hrLeave);
  const eps_api = api(eps_env);
  const finance_api = api(finance_env);

  return {
    GetRSA: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return eps_api.get(`/v2/SelfServices/getrsa${params}`, data);
    },

    // GetAllPayroll: function (data) {
    //   const { currentPage, pageSize, filter, searchQuery, startDate, endDate, sort } =
    //     data;
    //     return hr_api.get(`/PayrollComponent?pageNumber=${currentPage || 1}&perPage=${
    //       pageSize || 10
    //     }&Status=${filter}&Search=${searchQuery || ""}&StartDate=${startDate || ""}&EndDate=${
    //       endDate || ""
    //     }&SortBy=${sort || ""}`, data);
    // },

    GetAllPayroll: function (data) {
      const {
        currentPage,
        pageSize,
        filter,
        searchQuery,
        startDate,
        endDate,
        sort,
      } = data;
      return hr_api.get(
        `/PayrollComponent/?pageNumber=${currentPage || 1}&perPage=${
          pageSize || 1
        }&status=${filter || ""}&Search=${searchQuery || ""}&StartDate=${
          startDate || ""
        }&EndDate=${endDate || ""}&SortBy=${sort}`,
        data
      );
    },

    MyUpdatePayrollSetup: function (data) {
      return hr_api.post(`/PayrollComponent/update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetLoanSetup: function (data) {
      const {
        currentPage,
        pageSize,
        filter,
        searchQuery,
        startDate,
        endDate,
        sort,
      } = data;

      // Build the query parameters dynamically
      const queryParams = new URLSearchParams();

      if (currentPage !== undefined)
        queryParams.append("pageNumber", currentPage);
      if (pageSize !== undefined) queryParams.append("perPage", pageSize);
      if (filter !== undefined) queryParams.append("status", filter);
      if (searchQuery !== undefined) queryParams.append("Search", searchQuery);
      if (startDate !== undefined) queryParams.append("StartDate", startDate);
      if (endDate !== undefined) queryParams.append("EndDate", endDate);
      if (sort !== undefined) queryParams.append("SortBy", sort);

      // Construct the URL with the query parameters
      const url = `/LoanSetUp/?${queryParams.toString()}`;

      return hr_api.get(url, data);
    },

    CreateLoan: function (data) {
      return hr_api.post(`/LoanSetUp`, data);
    },

    UpdateLoan: function (data) {
      return hr_api.post(`/LoanSetUp/update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    DeleteLoan: function (data) {
      return hr_api.post(`/LoanSetUp/deleteLoanType`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    // GetLoanRuleSetup: function (data) {
    //   const {
    //     currentPage,
    //     pageSize,
    //     filter,
    //     searchQuery,
    //     startDate,
    //     endDate,
    //     sort,
    //   } = data;
    //   return hr_api.get(
    //     `/LoanSetUp/loanRules/?pageNumber=${currentPage || 1}&perPage=${
    //       pageSize || 1
    //     }&status=${filter || ""}&Search=${searchQuery || ""}&StartDate=${
    //       startDate || ""
    //     }&EndDate=${endDate || ""}&SortBy=${sort}`,
    //     data
    //   );
    // },

    GetLoanRuleSetup: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/LoanSetUp/loanRules${params}`, data);
    },

    CreateLoanRule: function (data) {
      return hr_api.post(`/LoanSetUp/loanRule`, data);
    },

    UpdateLoanRule: function (data) {
      return hr_api.post(`/LoanSetUp/updateLoanRule`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    DeleteLoanRule: function (data) {
      return hr_api.post(`/LoanSetUp/deleteLoanRule`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetEmployeeGroup: function (data) {
      const {
        currentPage,
        pageSize,
        filter,
        searchQuery,
        startDate,
        endDate,
        sort,
      } = data;
      return hr_api.get(
        `/EmployeeGroup/?pageNumber=${currentPage || 1}&perPage=${
          pageSize || 1
        }&approvalStatus=${filter || ""}&Search=${
          searchQuery || ""
        }&StartDate=${startDate || ""}&EndDate=${endDate || ""}&SortBy=${sort}`,
        data
      );
    },

    ApproveEmployeeGroup: function (data) {
      return hr_api.post(`/EmployeeGroup/approve`, data);
    },

    DeclineEmployeeGroup: function (data) {
      return hr_api.post(`/EmployeeGroup/decline`, data);
    },

    CancelEmployeeGroup: function (data) {
      return hr_api.post(`/EmployeeGroup/cancel`, data);
    },

    CreateEmployeeGroup: function (data) {
      return hr_api.post(`/EmployeeGroup`, data);
    },

    GetEmployeeCadrePosition: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/EmployeeCadrePosition${params}`, data);
    },

    GetEmployeeCadreLevels: function (data) {
      return hr_api.get(
        `/EmployeeCadrePosition/alllevel?pageSize=${data.pageSize}&pageNumber=${data.pageNumber}&Status=${data.Status}`,
        data
      );
    },

    ApproveEmployeeCadrePosition: function (data) {
      return hr_api.post(`/EmployeeCadrePosition/approve`, data);
    },

    DeclineEmployeeCadrePosition: function (data) {
      return hr_api.post(`/EmployeeCadrePosition/decline`, data);
    },

    CancelEmployeeCadrePosition: function (data) {
      return hr_api.post(`/EmployeeCadrePosition/cancel`, data);
    },

    CreateEmployeeCadrePosition: function (data) {
      return hr_api.post(`/EmployeeCadrePosition`, data);
    },

    MyUpdateEmployeeCadrePosition: function (data) {
      return hr_api.post(`/EmployeeCadrePosition/update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    MyUpdateAttendanceClock: function (data) {
      return hr_api.post(`/AttendanceSetUp/update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetEmployeeCadrePositionLevel: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/EmployeeCadrePosition/alllevel${params}`, data);
    },

    ApproveEmployeeCadrePositionLevel: function (data) {
      return hr_api.post(`/EmployeeCadrePosition/approvelevel`, data);
    },

    DeclineEmployeeCadrePositionLevel: function (data) {
      return hr_api.post(`/EmployeeCadrePosition/declinelevel`, data);
    },

    CancelEmployeeCadrePositionLevel: function (data) {
      return hr_api.post(`/EmployeeCadrePosition/cancellevel`, data);
    },

    CreateEmployeeCadrePositionLevel: function (data) {
      return hr_api.post(`/EmployeeCadrePosition/level`, data);
    },

    MyUpdateEmployeeCadrePositionLevel: function (data) {
      return hr_api.post(`/EmployeeCadrePosition/updatelevel`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetAllLoanRequisition: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/LoanRequisition${params}`, data);
    },

    ApproveLoanRequisition: function (data) {
      return hr_api.post(`/LoanRequisition/approve`, data);
    },

    DeclineLoanRequisition: function (data) {
      return hr_api.post(`/LoanRequisition/decline`, data);
    },

    CancelLoanRequisition: function (data) {
      return hr_api.post(`/LoanRequisition/cancel`, data);
    },

    CreateLoanRequisition: function (data) {
      return hr_api.post(`/LoanRequisition`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetSingleLoanRequisition: function (data) {
      return hr_api.get(`/LoanRequisition/${data}?id=${data}`, data);
    },

    UpdateLoanRequisition: function (data) {
      return hr_api.post(`/LoanRequisition/update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetDepartment: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/Department/AllDepartment${params}`, data);
    },

    GetPayrollStructure: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/PayrollStructure${params}`, data);
    },

    ApprovePayrollStructure: function (data) {
      return hr_api.post(`/PayrollStructure/approve`, data);
    },

    DeclinePayrollStructure: function (data) {
      return hr_api.post(`/PayrollStructure/decline`, data);
    },

    CancelPayrollStructure: function (data) {
      return hr_api.post(`/PayrollStructure/cancel`, data);
    },

    CreatePayrollStructure: function (data) {
      return hr_api.post(`/PayrollStructure`, data);
    },

    MyUpdatePayrollStructure: function (data) {
      return hr_api.post(`/PayrollStructure/update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetSinglePayrollStructure: function (data) {
      return hr_api.get(`/PayrollStructure/${data}?id=${data}`, data);
    },

    ApproveApplication: function (data) {
      return hr_api.post(
        `/RecruitmentSetUpStatus/ApproveApplicationChannelCommand`,
        data
      );
    },

    DeclineApplication: function (data) {
      return hr_api.post(
        `/RecruitmentSetUpStatus/DeclineApplicationChannelCommand`,
        data
      );
    },

    CancelApplication: function (data) {
      return hr_api.post(
        `/RecruitmentSetUpStatus/CancelApplicationChannelCommand`,
        data
      );
    },

    ApproveMetric: function (data) {
      return hr_api.post(`/RecruitmentSetUpStatus/ApprovalMetricCommand`, data);
    },

    DeclineMetric: function (data) {
      return hr_api.post(`/RecruitmentSetUpStatus/DeclineMetricCommand`, data);
    },

    CancelMetric: function (data) {
      return hr_api.post(`/RecruitmentSetUpStatus/CancelMetricCommand`, data);
    },

    ApproveJob: function (data) {
      return hr_api.post(
        `/RecruitmentSetUpStatus/ApproveRecruitmentJobTileSetUpCommand`,
        data
      );
    },

    DeclineJob: function (data) {
      return hr_api.post(
        `/RecruitmentSetUpStatus/DeclineRecruitmentJobTileSetUpCommand`,
        data
      );
    },

    CancelJob: function (data) {
      return hr_api.post(
        `/RecruitmentSetUpStatus/CancelRecruitmentJobTileSetUpCommand`,
        data
      );
    },

    ApproveSkill: function (data) {
      return hr_api.post(`/RecruitmentSetUpStatus/ApproveSkillsCommand`, data);
    },

    DeclineSkill: function (data) {
      return hr_api.post(`/RecruitmentSetUpStatus/DeclineSkillsCommand`, data);
    },

    CancelSkill: function (data) {
      return hr_api.post(`/RecruitmentSetUpStatus/CancelSkillsCommand`, data);
    },

    ApproveQualification: function (data) {
      return hr_api.post(
        `/RecruitmentSetUpStatus/ApproveQualificationSetUpCommand`,
        data
      );
    },

    DeclineQualification: function (data) {
      return hr_api.post(
        `/RecruitmentSetUpStatus/DeclineQualificationSetUpCommand`,
        data
      );
    },

    CancelQualification: function (data) {
      return hr_api.post(
        `/RecruitmentSetUpStatus/CancelQualificationSetUpCommand`,
        data
      );
    },
    // GetAttendanceClock: function (data) {
    //   const {
    //     currentPage,
    //     pageSize,
    //     filter,
    //     searchQuery,
    //     startDate,
    //     endDate,
    //     sort,
    //   } = data;
    //   return hr_api.get(
    //     `/AttendanceSetUp/?pageNumber=${currentPage || 1}&perPage=${
    //       pageSize || 1
    //     }&status=${filter || ""}&Search=${searchQuery || ""}&StartDate=${
    //       startDate || ""
    //     }&EndDate=${endDate || ""}&SortBy=${sort}`,
    //     data
    //   );
    // },

    GetAllHospital: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/MedicalServiceSetUp/AllHospital${params}`, data);
    },

    CreateHospital: function (data) {
      return hr_api.post(`/MedicalServiceSetUp`, data);
    },

    GetSingleHospital: function (data) {
      return hr_api.get(`/MedicalServiceSetUp?id=${data}`, data);
    },

    UpdateHospital: function (data) {
      return hr_api.post(`/MedicalServiceSetUp/Update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    ApproveHospital: function (data) {
      return hr_api.patch(`/MedicalServiceSetUp/Approve`, data);
    },

    DeclineHospital: function (data) {
      return hr_api.patch(`/MedicalServiceSetUp/Decline`, data);
    },

    CancelHospital: function (data) {
      return hr_api.patch(`/MedicalServiceSetUp/Cancel`, data);
    },

    GetAllMedicalLimit: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/MedicalLimitSetup/All${params}`, data);
    },

    CreateMedicalLimit: function (data) {
      return hr_api.post(`/MedicalLimitSetup`, data);
    },

    GetSingleMedicalLimit: function (data) {
      return hr_api.get(`/MedicalLimitSetup/${data}?id=${data}`, data);
    },

    UpdateMedicalLimit: function (data) {
      return hr_api.post(`/MedicalLimitSetup/Update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    ApproveMedicalLimit: function (data) {
      return hr_api.patch(`/MedicalLimitSetup/Approve`, data);
    },

    DeclineMedicalLimit: function (data) {
      return hr_api.patch(`/MedicalLimitSetup/Decline`, data);
    },

    CancelMedicalLimit: function (data) {
      return hr_api.patch(`/MedicalLimitSetup/Cancel`, data);
    },

    GetAttendanceClock: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/AttendanceSetUp${params}`, data);
    },

    // GetAllPayroll: function (data) {
    //   let params = "?";
    //   for (let [key, value] of Object.entries(data)) {
    //     params = params + `${key}=${value}&`;
    //   }
    //   params = params.replace(/^&/, "");
    //   return hr_api.get(`/PayrollComponent${params}`, data);
    // },

    ApprovePayroll: function (data) {
      return hr_api.post(`/PayrollComponent/approve`, data);
    },

    DeclinePayroll: function (data) {
      return hr_api.post(`/PayrollComponent/decline`, data);
    },

    CancelPayroll: function (data) {
      return hr_api.post(`/PayrollComponent/cancel`, data);
    },

    GetSinglePayroll: function (data) {
      return hr_api.get(`/PayrollComponent/${data}?id=${data}`, data);
    },

    GetSingleEmployeeCadrePosition: function (data) {
      return hr_api.get(`/EmployeeCadrePosition/${data}?id=${data}`, data);
    },

    // GetSingleEmployeeCadrePositionLevel: function (data) {
    //   return hr_api.get(`/EmployeeCadrePosition/levelId`, data);
    // },

    GetSingleEmployeeCadrePositionLevel: function (data) {
      return hr_api.get(`/EmployeeCadrePosition/levelId?id=${data}`, data);
    },

    GetEmployeeById: function (data) {
      return hr_api.get(`/Employee?id=${data}`, data);
    },

    GetAllEmployees: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/Employee/GetAllEmployees${params}`, data);
    },

    GetLeaveTypes: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/EmployeeLeaveType${params}`, data);
    },

    GetLeaveReasons: function (data) {
      return hr_leave_api.get(
        `/Reason?pageNumber=${data.pageNumber}&PageSize=${data.perPage}`,
        data
      );
    },

    // https://documentservice-dev.nlpcpfa.com:8021/api/Definitions?Module=17&Search=Qualification&PageSize=10&PageNumber=1
    GetDocumentDifinition: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_leave_api.get(`/Definitions${params}`, data);
    },

    GetDocumentDifinitionById: function (id) {
      return hr_leave_api.get(`/Definitions/Id?Id=${id}`, id);
    },

    GetAllDepartments: function (data) {
      return hr_api.get(
        `/Department/AllDepartment${CreateQueryParams(data)}`,
        data
      );
    },

    CreatePayroll: function (data) {
      return hr_api.post(`/PayrollComponent`, data);
    },

    GetJobTitle: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/RecruitmentSetUp/AllJobTitle${params}`, data);
    },

    CreateJobTitle: function (data) {
      return hr_api.post(`/RecruitmentSetUp/JobTitle`, data);
    },

    GetSingleJobTitle: function (data) {
      return hr_api.get(`/RecruitmentSetUp/JobTitle?id=${data}`, data);
    },

    UpdateJobTitle: function (data) {
      return hr_api.post(`/RecruitmentSetUp/UpdateJobTile`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetSkills: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/RecruitmentSetUp/AllSkills${params}`, data);
    },

    CreateSkills: function (data) {
      return hr_api.post(`/RecruitmentSetUp/Skills`, data);
    },

    GetSingleSkill: function (data) {
      return hr_api.get(`/RecruitmentSetUp/Skills?id=${data}`, data);
    },

    UpdateSkills: function (data) {
      return hr_api.post(`/RecruitmentSetUp/UpdateSkills`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetQualifications: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(
        `/RecruitmentSetUp/GetAllQualificationSetUpquery${params}`,
        data
      );
    },

    CreateQualifications: function (data) {
      return hr_api.post(`/RecruitmentSetUp/QualificationSetUp`, data);
    },

    GetSingleQualification: function (data) {
      return hr_api.get(
        `/RecruitmentSetUp/GetQualificationSetUpByIdquery?id=${data}`,
        data
      );
    },

    UpdateQualifications: function (data) {
      return hr_api.post(`/RecruitmentSetUp/UpdateQualification`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetMetrics: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/RecruitmentSetUp/GetAllMetricQuery${params}`, data);
    },

    CreateMetrics: function (data) {
      return hr_api.post(`/RecruitmentSetUp/CreateMetricCommand`, data);
    },

    GetSingleMetrics: function (data) {
      return hr_api.get(
        `/RecruitmentSetUp/GetMetricByIdquery?id=${data}`,
        data
      );
    },

    UpdateMetrics: function (data) {
      return hr_api.post(`/RecruitmentSetUp/UpdateMetricCommand`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetApplication: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(
        `/RecruitmentSetUp/GetAllApplicationChannelQuery${params}`,
        data
      );
    },

    CreateApplication: function (data) {
      return hr_api.post(
        `/RecruitmentSetUp/CreateApplicationChannelCommand`,
        data
      );
    },

    CreateJobListing: function (data) {
      return hr_api.post(`/JobListing`, data);
    },

    // JobListing/GetAllJobListingByQuery
    GetJobListing: function (data) {
      return hr_api.get(
        `/JobListing/GetAllJobListingByQuery${CreateQueryParams(data)}`,
        data
      );
    },

    // JobListing/GetSingleJobListing
    GetSingleJobListing: function (data) {
      return hr_api.get(`/JobListing${CreateQueryParams(data)}`, data);
    },

    // UpdateJobListing
    UpdateJobListing: function (data) {
      return hr_api.post(`/JobListing/Update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    // JobListing/ApprovalJobListingCommand
    ApproveJobListing: function (data) {
      return hr_api.post(`/JobListing/ApprovalJobListingCommand`, data);
    },

    // JobListing/DeclineJobListingCommand
    DeclineJobListing: function (data) {
      return hr_api.post(`/JobListing/DeclineJobListingCommand`, data);
    },

    // JobListing/CancelJobListingCommand
    CancelJobListing: function (data) {
      return hr_api.post(`/JobListing/CancelJobListingCommand`, data);
    },

    GetSingleApplication: function (data) {
      return hr_api.get(
        `/RecruitmentSetUp/GetApplicationChannelByIdQuery?id=${data}`,
        data
      );
    },

    UpdateApplication: function (data) {
      return hr_api.post(
        `/RecruitmentSetUp/UpdateApplicationChannelCommand`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    },

    // Applicant/AttachToCadreLevel
    AttachApplicantToCadreLevel: function (data) {
      return hr_api.post(`/Applicant/AttachToCadreLevel`, data);
    },

    ScheduleTnterviewWithCandidate: function (data) {
      return hr_api.post(`/Applicant/ScheduleInterview`, data);
    },

    RescheduleTnterviewWithCandidate: function (data) {
      return hr_api.post(`/Applicant/RescheduleInterview`, data);
    },

    submitApplicantGrade: function (data) {
      return hr_api.post(`/EvaluateApplicant`, data);
    },

    MoveCandidateToSelected: function (data) {
      return hr_api.post(`/Applicant/SelectApplicant`, data);
    },

    AssignEmployeesToGrade: function (data) {
      return hr_api.post(`/Applicant/AttachApplicantGrading`, data);
    },

    // Applicant/AttacthToCadreLevel/approve
    ApproveAttachApplicantToCadreLevel: function (data) {
      return hr_api.post(`/Applicant/AttacthToCadreLevel/approve`, data);
    },

    // Applicant/AttacthToCadreLevel/reject
    DeclineAttachApplicantToCadreLevel: function (data) {
      return hr_api.post(`/Applicant/AttacthToCadreLevel/reject`, data);
    },

    // Applicant/medicals/upload
    UploadAppilcantMedicalForm: function (data) {
      return hr_api.post(`/Applicant/medicals/upload`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    // api/Applicant/job-offer?id=14
    GetJobOffer: function (data) {
      return hr_api.get(`/Applicant/job-offer?id=${data}`, data);
    },

    // Applicant/AcceptOffer
    AcceptJobOffer: function (data) {
      return hr_api.post(`/Applicant/AcceptOffer`, data);
    },

    // Applicant/RejectOffer
    RejectJobOffer: function (data) {
      return hr_api.post(`/Applicant/RejectOffer`, data);
    },

    CreateAttendanceClock: function (data) {
      return hr_api.post(`/AttendanceSetUp`, data);
    },

    CreateLeaveType: function (data) {
      return hr_api.post(`/EmployeeLeaveType`, data);
    },

    UpdateLeaveType: function (data) {
      return hr_api.post(`/EmployeeLeaveType/update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    MyUpdateEmployeeGroup: function (data) {
      return hr_api.post(`/EmployeeGroup/Update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetSingleDepartment: function (data) {
      let params = data ? `?id=${data}` : "";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return (
        hr_api.get(`/Department${params}`, data),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    },

    GetUnits: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/Container/AllContainer${params}`, data);
    },

    CreateLeaveRequest: function (data) {
      return hr_api.post(`/EmployeeLeaveRequisition`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    AddConsent: function (data) {
      return eps_api.post(`/v2/SelfServices/consent`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    UpdateLeaveRequest: function (data) {
      console.log(data, "DATa");
      return hr_api.post(`/EmployeeLeaveRequisition/update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    GetSingleLeaveRequest: function (data) {
      return hr_api.get(`/EmployeeLeaveRequisition/${data}`, data);
    },
    GetMyLeaveRequest: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/EmployeeLeaveRequisition/my${params}`, data);
    },

    GetAllLeaveRequest: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/EmployeeLeaveRequisition/${params}`, data);
    },

    GetByDepartment: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(
        `/EmployeeLeaveRequisition/GetByDepartment${params}`,
        data
      );
    },

    ApproveLeave: function (data) {
      return hr_api.post(`/EmployeeLeaveRequisition/approve`, data);
    },

    DeclineLeave: function (data) {
      return hr_api.post(`/EmployeeLeaveRequisition/reject`, data);
    },

    CancelLeave: function (data) {
      return hr_api.post(`/EmployeeLeaveRequisition/cancel`, data);
    },
    CreateLeaveRecall: function (data) {
      return hr_api.post(`/EmployeeLeaveRecall`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetSingleLeaveRecall: function (data) {
      return hr_api.get(`/EmployeeLeaveRecall/${data}`, data);
    },

    GetConfirmAction: function (data) {
      console.log(data);
      return hr_api.post(`/EmployeeLeaveRequisition/BackAction`, data);
    },

    ApproveLeaveRecall: function (data) {
      return hr_api.post(`/EmployeeLeaveRecall/approve`, data);
    },

    RejectLeaveRecall: function (data) {
      console.log(data);
      return hr_api.post(`/EmployeeLeaveRecall/reject`, data);
    },

    CancelLeaveRecall: function (data) {
      return hr_api.post(`/EmployeeLeaveRecall/cancel`, data);
    },

    //Exit Management starts here
    CreateExitRequisition: function (data) {
      return hr_api.post(`/ExitManagement`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    UpdateExitRequisition: function (data) {
      return hr_api.post(`/ExitManagement/update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    GetExitRequisition: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/ExitManagement${params}`, data);
    },

    GetMyExitRequisition: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/ExitManagement/my${params}`, data);
    },

    GetApplicant: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/Applicant/GetAllApplicationQuery${params}`, data);
    },

    CreateApplicant: function (data) {
      return hr_api.post(`/Applicant`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    GetSingleApplicant: function (data) {
      return hr_api.get(`/Applicant?id=${data}`, data);
    },

    MyUpdateApplicant: function (data) {
      return hr_api.post(`/Applicant/Update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    AcceptOffer: function (data) {
      return hr_api.post(`/Applicant/AcceptOffer`, data);
    },

    RejectOffer: function (data) {
      console.log(data);
      return hr_api.post(`/Applicant/RejectOffer`, data);
    },

    CloseOffer: function (data) {
      return hr_api.post(`/Applicant/CloseApplicantOffer`, data);
    },

    // GetSingleApplicant: function (data) {
    //   return hr_api.post(`/Applicant/SignInApplicant`, data);
    // },

    GetExtendedHMOClaims: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/ExtendedHMOClaims/All${params}`, data);
    },

    CreateExtendedHMOClaims: function (data) {
      return hr_api.post(`/ExtendedHMOClaims`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    CreateCreditFacility: function (data) {
      return finance_api.post(`/CreditFacility`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    DisableCreditFacility: function (data) {
      return finance_api.post(`/CreditFacility/delete`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    UpdateCreditFacility: function (data) {
      return finance_api.post(`/CreditFacility/update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetSingleExtendedHMOClaims: function (data) {
      return hr_api.get(`/ExtendedHMOClaims?id=${data}`, data);
    },

    MyUpdateExtendedHMOClaims: function (data) {
      return hr_api.post(`/ExtendedHMOClaims/Update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    ApproveExtendedHMOClaims: function (data) {
      return hr_api.post(`/ExtendedHMOClaims/Approve`, data);
    },

    DeclineExtendedHMOClaims: function (data) {
      console.log(data);
      return hr_api.post(`/ExtendedHMOClaims/Decline`, data);
    },

    CancelExtendedHMOClaims: function (data) {
      return hr_api.post(`/ExtendedHMOClaims/Cancel`, data);
    },

    GetExitRequisitionHOD: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`ExitManagement/HOD${params}`, data);
    },

    GetSingleExitRequisition: function (data) {
      return hr_api.get(`/ExitManagement/${data}`, data);
    },

    ApproveExit: function (data) {
      return hr_api.post(`/ExitManagement/approve`, data);
    },

    CancelExit: function (data) {
      return hr_api.post(`ExitManagement/cancel`, data);
    },

    DeclineExit: function (data) {
      return hr_api.post(`/ExitManagement/decline`, data);
    },
    //exit management ends here

    //exit discussion
    CreateExitDiscussionQuestions: function (data) {
      return hr_api.post(`/ExitDiscussion/creatediscussionquestion`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    EnabledDisableExitDiscussionQuestions: function (data) {
      return hr_api.post(`/ExitDiscussion/enabledisable`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetExitDiscussionQuestion: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(
        `/ExitDiscussion/getalldiscussionquestion${params}`,
        data
      );
    },

    CreateExitDiscussion: function (data) {
      return hr_api.post(`/ExitDiscussion`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    // ExitDiscussion/2
    GetExistDiscussionById: function (data) {
      return hr_api.get(`/ExitDiscussion/${data}`, data);
    },

    GetExitDiscussion: function (data) {
      const { ExitRequestId } = data;
      return hr_api.get(
        `/ExitDiscussion/getexitdiscussion?ExitRequestId=${ExitRequestId}`,
        data
      );
    },

    //ExitDiscussion/getexitdiscussion?ExitRequestId=1

    UpdateExitDiscussionQuestions: function (data) {
      return hr_api.post(`ExitDiscussion/updatediscussionquestion`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    AddDiscussionRemarks: function (data) {
      console.log(data);
      return hr_api.post(`/ExitDiscussion/AddRemarks`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    //end exit discussion

    // start query setup
    GetQuerySetup: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/QuerySetUp${params}`, data);
    },

    CreateQuerySetup: function (data) {
      return hr_api.post(`/QuerySetUp`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    UpdateQuerySetup: function (data) {
      return hr_api.post(`QuerySetUp/update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    //end query setup
    GetQueries: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/Query${params}`, data);
    },

    GetSingleQuery: function (data) {
      console.log(data);
      return hr_api.get(`/Query/${data}`, data);
    },

    //start Panel setup
    CreateQueryPanel: function (data) {
      return hr_api.post(`/QueryManagement`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    CreateQueryReport: function (data) {
      return hr_api.post(`/QueryManagement/panelreport`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetQueryManagement: function (data) {
      console.log(data);
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/QueryManagement${params}`, data);
    },

    GetSingleQueryManagement: function (data) {
      return hr_api.get(`/QueryManagement/ById?id=${data}`, data);
    },

    UpdateQueryPanel: function (data) {
      return hr_api.post(`/QueryManagement/update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    ApprovePanelReport: function (data) {
      return hr_api.post(`/QueryManagement/approve`, data);
    },
    RejectPanelReport: function (data) {
      return hr_api.post(`/QueryManagement/reject`, data);
    },
    //end Panel setup

    //start overtime type

    GetOvertimeType: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/OvertimeType${params}`, data);
    },

    DeleteOvertimeType: function (data) {
      console.log("data", data);
      return hr_api.post(`/OvertimeType/delete/${data?.id}`, data);
    },

    CreateOvertimeType: function (data) {
      return hr_api.post(`/OvertimeType`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    UpdateOvertimeType: function (data) {
      return hr_api.post(`/OvertimeType/update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
    //end overtime type

    //stert overtime requisition
    GetAllOvertimeRequisition: function (data) {
      console.log(data);
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`EmployeeOvertimeRequisition${params}`, data);
    },

    GetAllOvertimeRequisitionWorkflow: function (data) {
      console.log(data);
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(
        `EmployeeOvertimeRequisition/ApprovalWorkflow${params}`,
        data
      );
    },

    GetAllOvertimeRequisitionHOD: function (data) {
      console.log(data);
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`EmployeeOvertimeRequisition/GetHODs${params}`, data);
    },
    GetAllOvertimeRequisitionEDS: function (data) {
      console.log(data);
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`EmployeeOvertimeRequisition/GetEDs${params}`, data);
    },

    GetOvertimeRequisition: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`EmployeeOvertimeRequisition/my${params}`, data);
    },

    CreateOvertime: function (data) {
      return hr_api.post(`/EmployeeOvertimeRequisition`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    UpdateOvertime: function (data) {
      return hr_api.post(`/EmployeeOvertimeRequisition/update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    CancelOvertimeRequisition: function (data) {
      return hr_api.post(`/EmployeeOvertimeRequisition/cancel`, data);
    },

    GetSingleOvertimeRequisition: function (data) {
      return hr_api.get(`/EmployeeOvertimeRequisition/${data}`, data);
    },

    ApproveOvertimeRequest: function (data) {
      return hr_api.post(`/EmployeeOvertimeRequisition/approve`, data);
    },

    DeclineOvertimeRequest: function (data) {
      return hr_api.post(`EmployeeOvertimeRequisition/reject`, data);
    },

    ApproveOvertimeRequestBulk: function (data) {
      return hr_api.post(`/EmployeeOvertimeRequisition/approve/bulk`, data);
    },

    DeclineOvertimeRequestBulk: function (data) {
      return hr_api.post(`/EmployeeOvertimeRequisition/reject/bulk`, data);
    },
    //end overtime requisition

    GetEmployee: function (data) {
      return hr_api.get(
        `/Employee/GetAllEmployees${CreateQueryParams(data)}`,
        data
      );
    },

    UpdateEmployeInformation: function (data) {
      return hr_api.post(`/Employee/Update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    GetEmployeeBeneficiary: function (data) {
      return hr_api.get(
        `/EmployeeBeneficiary/MyEmployeeBeneficiary${CreateQueryParams(data)}`,
        data
      );
    },

    ApproveEmployeeBeneficiary: function (data) {
      return hr_api.post(`/EmployeeApproval/NOKAproval`, data);
    },

    DeclineEmployeeBeneficiary: function (data) {
      return hr_api.post(`/EmployeeApproval/NOKDecline`, data);
    },

    GetAllEmployeeBeneficiary: function (data) {
      return hr_api.get(
        `/EmployeeRSALinking/AllBeneficiary${CreateQueryParams(data)}`,
        data
      );
    },

    CreateEmployeBeneficiary: function (data) {
      return hr_api.post(`/EmployeeBeneficiary/CreateBeneficiary`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    GetEmployeeDesignation: function (data) {
      return hr_api.get(
        `/Designation/AllDesignation${CreateQueryParams(data)}`,
        data
      );
    },

    CreateMedicalRequisition: function (data) {
      return hr_api.post(`/EmployeeMedicalRequisition`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    // GetEmployeeMedicalRequisition: function (data) {
    //   return hr_api.get(`/EmployeeMedicalRequisition/All${CreateQueryParams(data)}`,
    //     data
    //   );
    // },

    GetEmployeeMedicalRequisition: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/EmployeeMedicalRequisition/All${params}`, data);
    },

    ApproveEmployeeMedicalRequisition: function (data) {
      return hr_api.post(`/EmployeeMedicalRequisition/Approve`, data);
    },

    DeclineEmployeeMedicalRequisition: function (data) {
      return hr_api.post(`/EmployeeMedicalRequisition/Decline`, data);
    },

    CancelEmployeeMedicalRequisition: function (data) {
      return hr_api.post(`/EmployeeMedicalRequisition/Cancel`, data);
    },

    CreateEmployeeMedicalRequisition: function (data) {
      return hr_api.post(`/EmployeeMedicalRequisition`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    MyUpdateEmployeeMedicalRequisition: function (data) {
      return hr_api.post(`/EmployeeMedicalRequisition/Update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    GetSingleEmployeeMedicalRequisition: function (data) {
      return hr_api.get(`/EmployeeMedicalRequisition?id=${data}`, data);
    },

    // ******Weekend Allowance**********
    GetMyWeekendAllowance: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/WeekendAllowanceRequisition/my${params}`, data);
    },

    getSingleWeekendAllowance: function (data) {
      return hr_api.get(`/WeekendAllowanceRequisition/${data}`, data);
    },

    GetAllWeekendAllowance: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/WeekendAllowanceRequisition${params}`, data);
    },

    GetAllWeekendAllowanceWorkflow: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(
        `/WeekendAllowanceRequisition/ApprovalWorkflow${params}`,
        data
      );
    },

    GetAllWeekendAllowanceByDepartment: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(
        `/WeekendAllowanceRequisition/GetByDepartment${params}`,
        data
      );
    },

    ApproveWeekendAllowance: function (data) {
      return hr_api.post(`/WeekendAllowanceRequisition/approve`, data);
    },

    DeclineWeekendAllowance: function (data) {
      return hr_api.post(`/WeekendAllowanceRequisition/decline`, data);
    },

    CancelWeekendAllowance: function (data) {
      return hr_api.post(`/WeekendAllowanceRequisition/cancel`, data);
    },

    CreateWeekendAllowance: function (data) {
      return hr_api.post(`/WeekendAllowanceRequisition`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    GetAllWeekendAllowanceSetup: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/WeekendAllowanceComponent${params}`, data);
    },

    CreateWeekendAllowanceSetup: function (data) {
      return hr_api.post(`/WeekendAllowanceComponent`, data);
    },

    UpdateWeekendAllowanceSetup: function (data) {
      return hr_api.post(`/WeekendAllowanceComponent/update`, data);
    },

    DeleteWeekendAllowanceSetup: function (data) {
      return hr_api.post(`/WeekendAllowanceComponent/delete`, data);
    },

    // WeekendAllowanceRequisition/update
    UpdateMyWeekendAllowance: function (data) {
      return hr_api.post(`/WeekendAllowanceRequisition/update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    // *************** Repayment Plan Setup ***********************

    SubmitRepaymentPlanSetup: function (data) {
      return hr_api.post(`/RepaymentPlanRule`, data);
    },

    GetAllRepaymentPlanSetup: function (data) {
      let { perPage, pageNumber, ApprovalStatus, Search } = data;

      // Create an object with only non-empty values
      const queryParams = {
        PageSize: perPage,
        PageNumber: pageNumber,
        ApprovalStatus: ApprovalStatus, // Include only if not empty
        Search: Search || undefined, // Include only if not empty
      };

      // Build the query string, filtering out undefined values
      const queryString = Object.keys(queryParams)
        .filter((key) => queryParams[key] !== undefined)
        .map((key) => `${key}=${queryParams[key]}`)
        .join("&");

      return hr_api.get(`/RepaymentPlanRule/All?${queryString}`, data);
    },

    UpdateRepaymentPlanSetup: function (data) {
      return hr_api.post(`/RepaymentPlanRule/update`, data);
    },

    GetRepaymentPlanSetupById: function (data) {
      return hr_api.get(`/RepaymentPlanRule?id=${data}`, data);
    },

    DeleteRepaymentPlanSetup: function (data) {
      return hr_api.post(`/RepaymentPlanRule/Decline`, data);
    },

    ApproveRepaymentPlanSetup: function (data) {
      return hr_api.post(`/RepaymentPlanRule/approve`, data);
    },

    // **************** Booking Service***********************

    SubmitBookingService: function (data) {
      return hr_api.post(`/BookingService`, data);
    },

    GetAllBookingService: function (data) {
      let { perPage, pageNumber, ApprovalStatus, Search } = data;

      // Create an object with only non-empty values
      const queryParams = {
        PageSize: perPage,
        PageNumber: pageNumber,
        ApprovalStatus: ApprovalStatus || undefined, // Include only if not empty
        Search: Search || undefined, // Include only if not empty
      };

      // Build the query string, filtering out undefined values
      const queryString = Object.keys(queryParams)
        .filter((key) => queryParams[key] !== undefined)
        .map((key) => `${key}=${queryParams[key]}`)
        .join("&");

      return hr_api.get(`/BookingService/all?${queryString}`, data);
    },

    UpdateBookingService: function (data) {
      return hr_api.post(`/BookingService/update`, data);
    },

    GetBookingServiceById: function (data) {
      return hr_api.get(`/BookingService?id=${data}`, data);
    },

    DeleteBookingService: function (data) {
      return hr_api.post(`/BookingService/delete`, data);
    },

    // *************** Auxiliary Service Setup ***********************

    SubmitAuxiliaryServiceSetup: function (data) {
      return hr_api.post(`/AuxiliaryServiceSetup`, data);
    },

    GetAllAuxiliaryServiceSetup: function (data) {
      let { perPage, pageNumber, ApprovalStatus, Search } = data;

      // Create an object with only non-empty values
      const queryParams = {
        PageSize: perPage,
        PageNumber: pageNumber,
        ApprovalStatus: ApprovalStatus || undefined, // Include only if not empty
        Search: Search || undefined, // Include only if not empty
      };

      // Build the query string, filtering out undefined values
      const queryString = Object.keys(queryParams)
        .filter((key) => queryParams[key] !== undefined)
        .map((key) => `${key}=${queryParams[key]}`)
        .join("&");

      return hr_api.get(
        `/AuxiliaryServiceSetUp/GetAllAuxiliaryServiceSetUpQuery?${queryString}`,
        data
      );
    },

    UpdateAuxiliaryServiceSetup: function (data) {
      return hr_api.post(`/AuxiliaryServiceSetup/update`, data);
    },

    GetAuxiliaryServiceSetupById: function (data) {
      return hr_api.get(`/AuxiliaryServiceSetup?id=${data}`, data);
    },

    DeleteAuxiliaryServiceSetup: function (data) {
      return hr_api.post(`/AuxiliaryServiceSetup/Decline`, data);
    },

    ApproveAuxiliaryServiceSetup: function (data) {
      return hr_api.post(`/AuxiliaryServiceSetup/approve`, data);
    },

    // *********** Auxiliary Service Request ***************

    SubmitAuxiliaryServiceRequest: function (data) {
      return hr_api.post(`/AuxiliaryServiceRequest`, data);
    },

    GetAllAuxiliaryServiceRequest: function (data) {
      let { pageSize, pageNumber, ApprovalStatus, Search } = data;

      // Create an object with only non-empty values
      const queryParams = {
        PageSize: pageSize,
        PageNumber: pageNumber,
        Status: ApprovalStatus || undefined, // Include only if not empty
        Search: Search || undefined, // Include only if not empty
      };

      // Build the query string, filtering out undefined values
      const queryString = Object.keys(queryParams)
        .filter((key) => queryParams[key] !== undefined)
        .map((key) => `${key}=${queryParams[key]}`)
        .join("&");
      return hr_api.get(`/AuxiliaryServiceRequest/all?${queryString}`, data);
    },

    UpdateAuxiliaryServiceRequest: function (data) {
      return hr_api.post(`/AuxiliaryServiceRequest/update`, data);
    },

    GetAuxiliaryServiceRequestById: function (data) {
      console.log("data from useParams:", data);
      return hr_api.get(`/AuxiliaryServiceRequest?id=${data}`, data);
    },

    DeleteAuxiliaryServiceRequest: function (data) {
      return hr_api.post(`/AuxiliaryServiceRequest/delete`, data);
    },

    ApproveAuxiliaryServiceRequest: function (data) {
      return hr_api.post(`/AuxiliaryServiceRequest/approve`, data);
    },

    DeclineAuxiliaryServiceRequest: function (data) {
      return hr_api.post(`/AuxiliaryServiceRequest/decline`, data);
    },

    // *********** Query Asset Damage ***************
    submitQueryAssetDamage: function (data) {
      return hr_api.post(`/Query/assetDamages`, data);
    },

    getAllQueryAssetDamage: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/Query/assetDamages${params}`, data);
    },

    getSingleQueryAssetDamage: function (data) {
      return hr_api.get(`/Query/assetDamages/${data}`, data);
    },

    updateQueryAssetDamage: function (data) {
      return hr_api.post(`/Query/assetDamages/update`, data);
    },

    deleteQueryAssetDamage: function (data) {
      return hr_api.post(`/Query/assetDamages/delete`, data);
    },

    approveQueryAssetDamage: function (data) {
      return hr_api.post(`/Query/assetDamages/approve`, data);
    },

    declineQueryAssetDamage: function (data) {
      return hr_api.post(`/Query/assetDamages/decline`, data);
    },

    // *****************************************************

    GetPaymentRequisition: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/PaymentRequisition${params}`, data);
    },

    GetPaymentRequisitionWorkflow: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/PaymentRequisition/ApprovalWorkflow${params}`, data);
    },

    GetPaymentRequisitionUUID: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/PaymentRequisition/uuId${params}`, data);
    },

    GetEDSPaymentRequisition: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/PaymentRequisition/GetEDs${params}`, data);
    },

    GetControlPaymentRequisition: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/PaymentRequisition/Control${params}`, data);
    },

    GetMyPaymentRequisition: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/PaymentRequisition/my${params}`, data);
    },

    ApprovePaymentRequisition: function (data) {
      return hr_api.post(`/PaymentRequisition/ApprovePaymentRequisition`, data);
    },

    DeclinePaymentRequisition: function (data) {
      return hr_api.post(`/PaymentRequisition/DeclinePaymentRequisition`, data);
    },

    CancelPaymentRequisition: function (data) {
      return hr_api.post(`/PaymentRequisition/Approve/Decline`, data);
    },

    CreatePaymentRequisition: function (data) {
      return hr_api.post(`/PaymentRequisition`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    MyUpdatePaymentRequisition: function (data) {
      console.log({ data });
      return hr_api.post(`/PaymentRequisition/Update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    GetSinglePaymentRequisition: function (data) {
      return hr_api.get(`/PaymentRequisition/uuId?uuId=${data}`, data);
    },

    GetDirectorate: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return hr_api.get(`/Directorate/AllDirectorate${params}`, data);
    },

    CreateDirectorate: function (data) {
      return hr_api.post(`/Directorate`, data);
    },

    PaymentRequisition: function (data) {
      return hr_api.post(`/PaymentRequisition`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },

    MyUpdateDirectorate: function (data) {
      return hr_api.post(`/Directorate/Update`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },

    GetSingleDirectorate: function (data) {
      return hr_api.get(`/Directorate/${data}`, data);
    },

    GetCountries: function (data) {
      return eps_api.get(
        `/v2/SelfServices/country${CreateQueryParams(data)}`,
        data
      );
    },

    GetEmployeeQualifications: function (data) {
      return hr_api.get(
        `/EmployeeRSALinking/AllEmployeeQualification${CreateQueryParams(
          data
        )}`,
        data
      );
    },

    GetEmployeeExtendedClaims: function (data) {
      return hr_api.get(
        `/ExtendedHMOClaims/All${CreateQueryParams(data)}`,
        data
      );
    },

    GetAllReferees: function (data) {
      return hr_api.get(
        `/EmployeeReferees/GetAllReferees${CreateQueryParams(data)}`,
        data
      );
    },

    //approval for HR

    ApproveEmployeeInformation: function (data) {
      return hr_api.post(
        `/EmployeeAprovalOrDeclineStatus/ApproveEmployeeInformation`,
        data
      );
    },

    DeclineEmployeeInformation: function (data) {
      return hr_api.post(
        `/EmployeeAprovalOrDeclineStatus/DeclineEmployeeInformation`,
        data
      );
    },

    ApproveEmployeeNOK: function (data) {
      return hr_api.post(`/EmployeeApproval/NOKAproval`, data);
    },

    DeclineEmployeeNOK: function (data) {
      return hr_api.post(`/EmployeeApproval/NOKDecline`, data);
    },

    ApproveEmployeeQualification: function (data) {
      return hr_api.post(`/EmployeeApproval/QualificationAproval`, data);
    },

    DeclineEmployeeQualification: function (data) {
      return hr_api.post(`/EmployeeApproval/QualificationDecline`, data);
    },

    ApproveEmployeeReferee: function (data) {
      return hr_api.post(`/EmployeeReferees/RefereesAproval`, data);
    },

    DeclineEmployeeReferee: function (data) {
      return hr_api.post(`/EmployeeReferees/RefereesDecline`, data);
    },
    // ApproveEmployeeMedicalRequisition: function (data) {
    //   return hr_api.post(`/EmployeeMedicalRequisition/Approve`, data);
    // },

    // DeclineEmployeeMedicalRequisition: function (data) {
    //   return hr_api.post(`/EmployeeMedicalRequisition/Decline`, data);
    // },

    ApproveEmployeeClaims: function (data) {
      return hr_api.post(`/ExtendedHMOClaims/Approve`, data);
    },

    DeclineEmployeeClaims: function (data) {
      return hr_api.post(`/ExtendedHMOClaims/Decline`, data);
    },
  };
};

//approval for HR

// Training Requisition
const trainingRequisition = () => {
  const root = process.env.REACT_APP_BACKEND_HR_URL;
  const route = api(root);

  return {
    CreateBeneficiary: function (data) {
      return route.post(`/EmployeeTrainingRequisition/Beneficiary`, data);
    },
    UpdateBeneficiary: function (data) {
      return route.post(`/EmployeeTrainingRequisition/UpdateBeneficiary`, data);
    },
    CreateRequisition: function (data) {
      return route.post(`/EmployeeTrainingRequisition`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    UpdateRequisition: function (data) {
      return route.post(`/EmployeeTrainingRequisition/Update`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    ApproveRequisition: function (data) {
      return route.post(`/EmployeeTrainingRequisition/Approve`, data);
    },
    DeclineRequisition: function (data) {
      return route.post(`/EmployeeTrainingRequisition/Decline`, data);
    },
    CancelRequisition: function (data) {
      return route.post(`/EmployeeTrainingRequisition/Cancel`, data);
    },
    GetAllEmployeeTraining: function (data) {
      const {
        currentPage,
        pageSize,
        filter,
        searchQuery,
        startDate,
        endDate,
        sort,
      } = data;
      return route.get(
        `/EmployeeTrainingRequisition?pageNumber=${currentPage || 1}&perPage=${
          pageSize || 1
        }&ApprovalStatus=${filter}&Search=${searchQuery}&StartDate=${startDate}&EndDate=${endDate}&SortBy=${sort}`,
        data
      );
    },
    GetEmployeeTrainingRequisition: function (data) {
      return route.get(`/EmployeeTrainingRequisition/uuId?uuId=${data}`, data);
    },
    ApproveOrDeclineBatchEmployeeTrainingRequest: function (data) {
      return route.post(
        `/EmployeeTrainingRequisition/TrainingRangeAprovalOrDecline`,
        data
      );
    },
  };
};

// Training Setup
const trainingSetup = () => {
  const root = process.env.REACT_APP_BACKEND_HR_URL;
  const route = api(root);

  return {
    CreateTrainingType: function (data) {
      return route.post(`/TrainingType`, data);
    },

    GetAllTrainingType: function (data) {
      const { currentPage, pageSize, searchQuery, startDate, endDate, sort } =
        data;
      return route.get(
        `/TrainingType?PageNumber=${currentPage || 1}&PageSize=${
          pageSize || 1
        }&Search=${searchQuery || ""}&StartDate=${startDate || ""}&EndDate=${
          endDate || ""
        }&SortBy=${sort || ""}`,
        data
      );
    },
    UpdateTrainingType: function (data) {
      return route.post(`/TrainingType/update`, data);
    },
    DeleteTrainingType: function (data) {
      console.log(data);
      return route.post(`/TrainingType/delete`, data);
    },
  };
};

export const HRServices = {
  trainingRequisition: trainingRequisition,
  trainingSetup: trainingSetup,
  hrService: hrService,
};
